import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:first-child) {
    margin-top: 2rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  color: #fff;
  background-color: rgba(0, 0, 0, 0.4);

  font-weight: 700;

  padding: 0.5rem;
`;

export const HeaderWrapper = styled.ul`
  width: 100%;
  max-width: 120rem;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.2rem;

  margin-bottom: 2rem;
  padding: 1rem;

  span {
    font-weight: 700;
    margin-right: 1rem;
  }
`;
